@for (item of items; track item; let i = $index) {
  <app-tab-item [ngClass]="{'active': item.active}" [id]="'tab-item--'+ i" (action)="SetActiveState($event, i)" [fullWidth]="items.length === 2" [label]="item.label | translate" [active]="item.active"></app-tab-item>
}
